import type { WithdrawalOrderConfiguration } from "@jti/fe-common";

type WithdrawalForm = NonNullable<WithdrawalOrderConfiguration["withdrawalForm"]>;
type WithdrawalSuccessContent = NonNullable<WithdrawalOrderConfiguration["withdrawalSuccessContent"]>;

type ConfiguredWithdrawalForm = Required<
  Pick<
    WithdrawalForm,
    | "title"
    | "description"
    | "firstNameLabel"
    | "lastNameLabel"
    | "emailLabel"
    | "phoneLabel"
    | "orderLabel"
    | "confirmButtonLabel"
    | "cancelButtonLabel"
  >
> &
  WithdrawalForm;

type ConfiguredWithdrawalSuccessContent = Required<
  Pick<
    WithdrawalSuccessContent,
    | "title"
    | "subtitle"
    | "successFirstNameLabel"
    | "successLastNameLabel"
    | "successEmailLabel"
    | "successPhoneLabel"
    | "successOrderLabel"
    | "successSubmittedOnLabel"
    | "content"
  >
> &
  WithdrawalSuccessContent;

export type ConfiguredWithdrawalFormModal = WithdrawalOrderConfiguration & {
  withdrawalForm: ConfiguredWithdrawalForm;
  withdrawalSuccessContent: ConfiguredWithdrawalSuccessContent;
};

const hasText = (value: string | null | undefined): value is string =>
  typeof value === "string" && value.trim().length > 0;

export const isWithdrawalFormModalConfigured = (
  config: WithdrawalOrderConfiguration | null | undefined
): config is ConfiguredWithdrawalFormModal => {
  const withdrawalForm = config?.withdrawalForm;
  const withdrawalSuccessContent = config?.withdrawalSuccessContent;

  return Boolean(
    withdrawalForm &&
    withdrawalSuccessContent &&
    hasText(withdrawalForm.title) &&
    hasText(withdrawalForm.description) &&
    hasText(withdrawalForm.firstNameLabel) &&
    hasText(withdrawalForm.lastNameLabel) &&
    hasText(withdrawalForm.emailLabel) &&
    hasText(withdrawalForm.phoneLabel) &&
    hasText(withdrawalForm.orderLabel) &&
    hasText(withdrawalForm.confirmButtonLabel) &&
    hasText(withdrawalForm.cancelButtonLabel) &&
    hasText(withdrawalSuccessContent.title) &&
    hasText(withdrawalSuccessContent.subtitle) &&
    hasText(withdrawalSuccessContent.successFirstNameLabel) &&
    hasText(withdrawalSuccessContent.successLastNameLabel) &&
    hasText(withdrawalSuccessContent.successEmailLabel) &&
    hasText(withdrawalSuccessContent.successPhoneLabel) &&
    hasText(withdrawalSuccessContent.successOrderLabel) &&
    hasText(withdrawalSuccessContent.successSubmittedOnLabel) &&
    hasText(withdrawalSuccessContent.content)
  );
};
